import { Link } from "react-router-dom";
import { LegalPage, LegalSection } from "../../components/shared/LegalPage";

export default function MentionsLegalesPage() {
  return (
    <LegalPage
      overline="Informations légales"
      title="Mentions"
      accent="légales"
      testId="legal-mentions-page"
    >
      <LegalSection title="Éditeur du site" testId="legal-mentions-editeur">
        <p className="font-semibold text-deepgreen">ART EVENT</p>
        <p>SASU — Société par actions simplifiée unipersonnelle</p>
        <p>Capital social : 500 €</p>
        <p>Siège social : 3 rue du Moulin, 59269 Artres, France</p>
        <p>SIREN : 981 326 028 — SIRET : 981 326 028 00025</p>
        <p>RCS : 981 326 028 R.C.S. Valenciennes</p>
        <p>TVA intracommunautaire : FR63 981326028</p>
        <p>Président : Théo Moenner</p>
        <p>E-mail : contact@art-events.fr — Téléphone : 06 88 60 83 53</p>
      </LegalSection>

      <LegalSection title="Directeur de la publication" testId="legal-mentions-directeur">
        <p>Théo Moenner, Président d'ART EVENT.</p>
      </LegalSection>

      <LegalSection title="Hébergement" testId="legal-mentions-hebergement">
        <p className="font-semibold text-deepgreen">IONOS SARL</p>
        <p>7 Place de la Gare, BP 70109, 57200 Sarreguemines Cedex, France</p>
      </LegalSection>

      <LegalSection title="Propriété intellectuelle" testId="legal-mentions-propriete">
        <p>
          L'ensemble des éléments composant ce site (textes, photographies, visuels, identité graphique, structure et
          contenus) est la propriété exclusive d'ART EVENT ou fait l'objet d'une autorisation d'utilisation. Toute
          reproduction, représentation, modification ou diffusion, totale ou partielle, sans autorisation écrite
          préalable d'ART EVENT est interdite.
        </p>
      </LegalSection>

      <LegalSection title="Responsabilité" testId="legal-mentions-responsabilite">
        <p>
          ART EVENT apporte le plus grand soin à l'exactitude des informations publiées sur ce site. Toutefois, ART EVENT
          ne saurait être tenue responsable des erreurs, omissions ou indisponibilités temporaires du site. Les
          informations relatives aux produits, prestations, disponibilités et tarifs sont fournies à titre indicatif et
          sont précisées dans le cadre de chaque demande de réservation. Les conditions applicables sont celles des
          Conditions Générales de Vente acceptées lors de la commande.
        </p>
      </LegalSection>

      <LegalSection title="Données personnelles" testId="legal-mentions-donnees">
        <p>
          Les traitements de données personnelles réalisés depuis ce site sont décrits dans notre{" "}
          <Link to="/politique-confidentialite" className="font-semibold text-deepgreen underline underline-offset-2 hover:text-gold" data-testid="legal-mentions-link-privacy">
            Politique de confidentialité
          </Link>
          .
        </p>
      </LegalSection>

      <LegalSection title="Cookies" testId="legal-mentions-cookies">
        <p>
          Les cookies et technologies similaires utilisés par ce site sont décrits dans notre{" "}
          <Link to="/politique-cookies" className="font-semibold text-deepgreen underline underline-offset-2 hover:text-gold" data-testid="legal-mentions-link-cookies">
            Politique relative aux cookies
          </Link>
          .
        </p>
      </LegalSection>
    </LegalPage>
  );
}
